import * as Yup from 'yup';
import { emailRegularExpression } from 'common/constants/formValidation';

export const emailValidation = Yup.string().matches(emailRegularExpression, 'Email address is invalid').required('Email is required');
